export default __webpack_public_path__ + "static/leverOn-c1f7bd3e60e205bf50a3aeb418aa5f30.png";